import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Container } from "@pixi/react";
import LineWinTextSymbol from "./LineWinTextSymbol";

const LineWinTextReel = forwardRef(
  ({ index, symbolWidth, symbolHeight, reelSpacing, overlaySymbols }, ref) => {
    // Only use one LineWinText at the 3rd symbol position (index 2)
    const lineWinTextRef = useRef(null);
    const reelContainerRef = useRef(null);

    // Expose methods to show/hide line win text
    // All calls now go to the single centered text, ignoring symbolIndex
    useImperativeHandle(ref, () => ({
      showLineWinText: (symbolIndex, winAmount) => {
        // Always show at the fixed position, ignore symbolIndex
        // Direct ref access (simpler, no race condition)
        lineWinTextRef.current?.showWinAmount(winAmount);
      },

      hideLineWinText: (symbolIndex) => {
        // Always hide the fixed position text, ignore symbolIndex
        lineWinTextRef.current?.hide();
      },

      hideAllLineWinTexts: () => {
        lineWinTextRef.current?.hide();
      },
    }));

    // Only render one LineWinTextSymbol at the bottom of the 3rd symbol (index 2)
    const fixedSymbolIndex = 2;
    const yPosition = symbolHeight * 2.5; // Bottom of 3rd symbol

    return (
      <Container
        ref={reelContainerRef}
        name={`line_win_text_reel_${index}`}
        x={reelSpacing * (index - 2)}
      >
        <LineWinTextSymbol
          key={fixedSymbolIndex}
          index={fixedSymbolIndex}
          y={yPosition}
          symbolWidth={symbolWidth}
          symbolHeight={symbolHeight}
          ref={lineWinTextRef}
        />
      </Container>
    );
  }
);

export default LineWinTextReel;
